import React, { Component } from 'react';
import * as ReactDOM from "react-dom";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useEffect } from "react";
import { useState } from 'react';
import axios from 'axios';
import { variables } from '../Variables';
import { useSelector } from "react-redux";
import mindfreeLogo from '../assets/images/login_Logo.svg';
import { getWhiseCalenderEventByIdService } from '../utils/EventService';

export const EventHandler = () => {
    const user = useSelector(state => state.user.user);
    const { contactId, eventId, clientId, officeId, contactFirstName, contactName, contactLanguage, estateId, agentId, internalEventId } = useParams();
    const [clientToken, setClientToken] = useState('');
    const [whiseUserToken, setWhiseUserToken] = useState('');
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);

    const [translationsForAllLanguages, setTranslationsForAllLanguages] = useState(null);
    const [selectedLanguageTranslations, setSelectedLanguageTranslations] = useState(null);

    const [eventStatus, setEventStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [confirmProcessStart, setConfirmProcessStart] = useState(false);
    const [processTextShow, setProcessTextShow] = useState(false);

    //const getToken = async () => {
    //    let url = "https://api.whise.eu/token";
    //    let headers = {
    //        'Content-Type': 'application/json'
    //    };
    //    let body = {
    //        "Username": variables.WhiseUser,
    //        "Password": variables.WhisePassword
    //    };

    //    try {
    //        let resp = await axios.post(url, body,
    //            {
    //                headers: headers
    //            });
    //        if (resp && resp.data && resp.data.token) {
    //            setWhiseUserToken(resp.data.token);
    //            getClientToken(resp.data.token);
    //        }
    //    }
    //    catch (e) {
    //        console.log(e);
    //    }
    //}

    //const getClientToken = async (token) => {
    //    try {
    //        let url = "https://api.whise.eu/v1/admin/clients/token";

    //        const config = {
    //            headers: {
    //                'Authorization': `Bearer ${token}`,
    //                'Content-Type': 'application/json'
    //            },
    //        };

    //        const response = await axios.post(url, { "clientId": clientId }, config);

    //        if (response.data) {
    //            getClientSettingFromWhise(response.data.token);
    //        }
    //    } catch (error) {
    //        console.log(error);
    //    }
    //}

    //const getSpecificAgentDetailFromLocalDB = async () => {
    //    try {
    //        let url = `${variables.API_URL}Estate/GetAgentById?agentId=${agentId}`;
    //        const jsonconfig = {
    //            headers: {
    //                'Accept': 'application/json',
    //                'Content-Type': 'application/json'
    //            }
    //        };

    //        const response = await axios.get(url, jsonconfig);
    //        if (response.data) {
    //            let agentLanguage = response.data.language || "fr-BE";
    //            getLanguageTranslations(agentLanguage);
    //        }
    //    } catch (error) {
    //        console.log(error);
    //        setEventStatus("api error");
    //        setIsLoading(false);
    //    }
    //}
    const getSpecificAgentDetailFromLocalDB = async () => {
        getLanguageTranslations(contactLanguage);
    }

    const getLanguageTranslations = async (agentLanguage) => {
        try {
            const url = variables.API_URL + `Settings/GetTranslationsForSiteByLang?siteName=agent`;
            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                let translations = response.data;
                if (Object.keys(translations).length > 0) {
                    setTranslationsForAllLanguages(translations);
                    let agentTranslation = translations[agentLanguage];
                    setSelectedLanguageTranslations(agentTranslation);

                    getEventDetailFromLocalDB();

                   // check event process status
                   // getAndUpdatEventProcessingStatus("in progress", "firstCAll");
                }
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    const getAndUpdatEventProcessingStatus = async (eventStatus, funCallStatus) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetAndUpdatEventProcessingStatus?eventInternalId=${internalEventId}&inputStatus=${eventStatus}`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data) {
                //console.log(response.data);
                if (funCallStatus == "firstCAll") {

                    setEventStatus(response.data);

                    // call to TBC to confirmed api
                    if (clientId && estateId && contactId && eventId && officeId && agentId && response.data == "start process") {
                        const getLatestEstateId = await getLatestEstateIdFromDB(estateId);
                        TBCtoConfirmEventHandling(clientId, getLatestEstateId, contactId, eventId, officeId, agentId, internalEventId);
                    }

                    if (response.data == "in progress" || response.data == "already processed" || response.data == "no condition was fulfilled") {
                        setIsLoading(false);
                    }
                }

            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    // get latest estate id from estate history db 
    const getLatestEstateIdFromDB = async (estateId) => {
        try {
            let url = `${variables.API_URL}Estate/GetEstateLatestId?inputEstateId=${estateId}`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data) {
                //console.log(response.data);
                return response.data;
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    // TBC to confirmed event fellow in backend
    const TBCtoConfirmEventHandling = async (clientId, estateId, contactId, eventId, officeId, agentId, internalEventId) => {
        try {
            setIsLoading(true);
            let url = `${variables.API_URL}LocalEvents/TobeConfirmedToConfirmedEventHandling`;

            let eventObj = eventId == 0 ? { eventId: +internalEventId } : { whiseEventId: +eventId }
            // console.log(latestEstateId);
            let body = {
                "clientId": +clientId,
                "estateId": +estateId,
                "contactId": +contactId,
                ...eventObj,
                "officeId": +officeId,
                "agentId": +agentId,
                "freeSlotToConfirmed": false
                //"whiseEventId"  : +eventId,
            }
            //console.log(body);
            const config = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.post(url, body, config);
            if (response.data) {
                console.log(response.data);
                setEventStatus(response.data.type);
                setIsLoading(false);

                //if (response.data.type != "error")

                if (response.data.type == "success" && response.data.message == "Event confirmed and local DB updated successfully") {
                    getAndUpdatEventProcessingStatus("already processed", "endCAll");
                }
            }
        } catch (error) {
            console.log(error);
            setEventStatus("api error");
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (clientId && agentId) {
            setIsLoading(true);
            setProcessTextShow(true);
            getSpecificAgentDetailFromLocalDB();
        }
    }, [agentId]);

    const closePage = () => {
        window.close();
    }

    const startConfirmProcess = () => {
        setConfirmProcessStart(false);

        // check event process status
        getAndUpdatEventProcessingStatus("in progress", "firstCAll");
    }

    const navigateDenialPage = async () => {

        // get latest estate id from estate history db 
        let getLatestEstateId = await getLatestEstateIdFromDB(estateId);
        let latestEstateId = getLatestEstateId || estateId; // set latest estate id or url estate id

        let refuseBtnExternalUrl = variables.AgentSiteURL + "eventdenialhandler/" + contactId + "/" + eventId + "/" + clientId + "/" + officeId + "/" + contactName + "/" + contactLanguage + "/" + latestEstateId + "/" + agentId + "/" + internalEventId;
        console.log(refuseBtnExternalUrl);
        window.location.href = refuseBtnExternalUrl;
    }

    const getEventDetailFromLocalDB = async (client_Token) => {
        try {
            let url = `${variables.API_URL}LocalEvents/checkEventAlreadyProcessed?EventId=${internalEventId}`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.get(url, config);
            if (response.data) {
                if (response.data.message != "already processed") {
                    setProcessTextShow(false);
                    setConfirmProcessStart(true);
                } else {
                    setIsLoading(false);
                    setProcessTextShow(false);
                    setEventStatus("already processed");
                    setConfirmProcessStart(false);
                }

            }
        } catch (error) {
            console.log("ErrorGetEventDetial:", error);
            setEventStatus("api error");
            setIsLoading(false);
        }

    }

    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100vh" }}>
                <img src={mindfreeLogo} className="mb-4 pb-5" alt="mindfree logo" />
                {
                    confirmProcessStart ?
                        <div>
                            <h6 className="fw-bold mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmAcceptBookingQuestion"] : "Please confirm, do you want to accept the booking?"}</h6>
                            <div className="text-center">
                                <button className="sm-accept-pg-btn site-btn-red site-btn-padd me-3 mb-3" onClick={navigateDenialPage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["noRefuseVisit"] : "No, refuse the visit"}</button>
                                <button className="sm-accept-pg-btn site-btn site-btn-padd mb-3" onClick={startConfirmProcess}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["yesConfirmVisit"] : "Yes, confirm the visit"}</button>
                            </div>
                        </div>
                        :
                        <div className="confirmation-message-container text-center">

                            {
                                isLoading ?
                                    <>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <h6 className={`fw-bold mt-4 ${selectedLanguageTranslations != null && processTextShow == false ? "d-block" : "d-none"}`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["processingChoiceMsg"] : "Working on it! We’re processing your choice—hang tight and please don't close this window just yet."}</h6>
                                    </>
                                    :
                                    eventStatus != "" && eventStatus == "success" ?
                                        <>
                                            <h6 className="fw-bold">{selectedLanguageTranslations != null ? selectedLanguageTranslations["visitSlotWillBeConfirmed"] : "La réservation de visite sera confirmé au contact dans les prochaines minutes"} (event {eventId == 0 ? internalEventId : eventId}).</h6>
                                            <h6 className="fw-bold mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["confirmationScreenYouMayCloseThisPageText"] : "You may close this page."}</h6>
                                            <div className="d-flex justify-content-center">
                                                <button className="site-btn-padd close-page-btn w-50" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                            </div>
                                        </>
                                        : eventStatus != "" && (eventStatus == "EventAlreadyProcessed" || eventStatus == "already processed") ?
                                            <>
                                                <h6 className="fw-bold mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventNotAvailableToAccept"] : `This event is no longer available to accept. Please check your WHISE calendar as it has either been accepted or deleted.`} </h6>
                                                <div className="d-flex justify-content-center">
                                                    <button className="site-btn-padd close-page-btn w-50" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                </div>
                                            </>
                                            : eventStatus != "" && eventStatus == "error" ?
                                                <>
                                                    <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["contactNotFoundForVisit"] : `Sorry we are not able to find the contact related to that visit. You need to manually create the confirmed visit event in your WHISE calendar. Don't forget to delete the to be confirmed after this.Our technical team is aware of this issue and will asap fix this in the next coming days..`} </h6>
                                                    <div className="d-flex justify-content-center">
                                                        <button className="site-btn-padd close-page-btn w-50" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                    </div>
                                                </>
                                                : eventStatus != "" && eventStatus == "in progress" ?
                                                    <>
                                                        <h6 className="fw-bold mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingAlreadyProcessing"] : "This booking is already being processed on another page. Please wait until the current process is completed."}</h6>
                                                        <div className="d-flex justify-content-center">
                                                            <button className="site-btn-padd close-page-btn w-50" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                        </div>
                                                    </>
                                                    : eventStatus != "" && (eventStatus == "api error" || eventStatus == "no condition was fulfilled") ?
                                                        <>
                                                            <h6 className="fw-bold mb-4">{selectedLanguageTranslations != null ? selectedLanguageTranslations["bookingSystemError"] : "We’re unable to process your request right now due to a system error. Please contact the support team if the issue persists."}</h6>
                                                            <div className="d-flex justify-content-center">
                                                                <button className="site-btn-padd close-page-btn w-50" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                            }
                        </div>
                }
            </div>
        </>
    )
}